import { UseEditorOptions } from "@tiptap/react";
import cn from "classnames";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Highlight from "@tiptap/extension-highlight";
import Color from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import Link from "@tiptap/extension-link";
import TextAlign from "@tiptap/extension-text-align";
import Placeholder from "@tiptap/extension-placeholder";
import { TextEditorProps } from "../types";

export const getEditorConfig = ({
  placeholder,
  className,
  value,
  onChange,
  onBlur,
  onFocus,
}: TextEditorProps): UseEditorOptions => ({
  extensions: [
    StarterKit,
    Underline,
    Color,
    TextStyle,
    Highlight.configure({ multicolor: true }),
    Placeholder.configure({ placeholder }),
    TextAlign.configure({
      types: ["heading", "paragraph"],
    }),
    Link.configure({
      openOnClick: false,
      autolink: true,
      defaultProtocol: "https",
    }),
  ],
  editorProps: {
    attributes: {
      class: cn(
        "min-h-40 px-5 py-3 rounded-b-20 border border-black-base/20 bg-inherit outline-none",
        className
      ),
    },
  },
  content: value,
  onUpdate: ({ editor }) => onChange(editor.getHTML()),
  onBlur,
  onFocus,
});
